import React from 'react';
import ManageChannel from '../Channel/ManageChannel';

const ChannelDetailProvider = (props: any) => {
    const { params } = props.match;
    return (
        <React.Fragment>
            <ManageChannel partyId={params?.partyId} domainId={params?.domainId} />
        </React.Fragment>
    );
}

export default ChannelDetailProvider;